import React from "react";
import { ArrowLeft, Menu } from "lucide-react";
import NotificationBell from "@/components/layout/NotificationBell";
import { useCruise } from "@/context/CruiseContext";
import CruiseSelector from "@/components/layout/CruiseSelector";
import { AccountMenu } from "@/components/layout/AccountMenu";

export const AuthenticatedHeader = ({ showNavigation = true, onAddCruise, onBack }) => {
  const { setMobileNavOpen } = useCruise();
  return (
    <header
      // Sticky under the iOS status bar (viewport-fit=cover): the top padding
      // adds env(safe-area-inset-top) so the controls never sit beneath it.
      className="sticky top-0 z-30 border-b border-slate-200/80 bg-white/95 px-3 pb-2 pt-[calc(env(safe-area-inset-top)+0.5rem)] backdrop-blur-xl sm:px-5 md:px-8"
      data-testid="cc-shared-account-header"
    >
      <div className="mx-auto flex min-h-12 max-w-[1600px] flex-wrap items-center gap-2 sm:gap-3 md:flex-nowrap">
        {showNavigation && (
          <button
            type="button"
            onClick={() => setMobileNavOpen(true)}
            className="order-1 flex h-11 w-11 shrink-0 items-center justify-center rounded-md outline-none transition-colors hover:bg-slate-100 focus-visible:ring-2 focus-visible:ring-[#1E6DE5] md:hidden"
            aria-label="Open navigation"
            data-testid="cc-shared-header-navigation"
          >
            <Menu className="h-5 w-5" />
          </button>
        )}
        {!showNavigation && onBack && (
          <button
            type="button"
            onClick={onBack}
            className="order-1 flex h-11 shrink-0 items-center gap-1 rounded-md px-2 text-[13px] font-semibold text-slate-700 outline-none transition-colors hover:bg-slate-100 focus-visible:ring-2 focus-visible:ring-[#1E6DE5]"
            aria-label="Back"
            data-testid="cc-shared-header-back"
          >
            <ArrowLeft className="h-5 w-5" />
            <span>Back</span>
          </button>
        )}
        <div className="order-4 min-w-0 basis-full md:order-2 md:flex md:min-w-[24rem] md:flex-1 md:basis-auto md:justify-end">
          <CruiseSelector variant="header" onAddCruise={onAddCruise} />
        </div>
        <NotificationBell className="order-2 ml-auto shrink-0 md:order-3 md:ml-0" />
        <div className="order-3 shrink-0 md:order-4"><AccountMenu /></div>
      </div>
    </header>
  );
};
